var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppButtonOk',{on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  リンク取得"),_c('v-icon',[_vm._v("link")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }